import React, { createContext, useMemo, Suspense } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { styled, getTokenValue, useTheme } from 'tamagui'

import { IconContext } from './context'

const StyledSVG = styled(Svg, {
  variants: {
    size: {
      '...size': (size) => {
        // Cast to Token since variant spread syntax ('...size') passes SizeTokens
        const sizeToken = size as Parameters<typeof getTokenValue>[0]
        return {
          width: getTokenValue(sizeToken, 'size'),
          height: getTokenValue(sizeToken, 'size'),
          minWidth: getTokenValue(sizeToken, 'size'),
          minHeight: getTokenValue(sizeToken, 'size'),
        }
      },
    },
  },

  defaultVariants: {
    size: '$5',
  },
} as const)

export const IconWrapper = StyledSVG.styleable<{
  color: Parameters<typeof getTokenValue>[0]
}>(({ children, color, ...props }, ref) => {
  const theme = useTheme()
  const contextValue = useMemo(() => {
    if (!color) {
      return { color: undefined }
    }

    // Try theme tokens first (e.g. $color, $colorMuted) for dark mode support
    const themeKey = color.startsWith('$') ? color.slice(1) : undefined
    if (themeKey && themeKey in theme) {
      const themeValue = (theme as Record<string, { val: string }>)[themeKey]?.val
      if (themeValue) {
        return { color: themeValue }
      }
    }

    const tokenColor = getTokenValue(color, 'color')

    return {
      color: tokenColor ? tokenColor : color,
    }
  }, [color, theme])

  return (
    <StyledSVG
      viewBox='0 0 24 24'
      //   xmlns='http://www.w3.org/2000/svg'
      {...props}
      ref={ref}
    >
      <IconContext.Provider value={contextValue}>
        <Suspense>{children}</Suspense>
      </IconContext.Provider>
    </StyledSVG>
  )
})
